export enum Roles {
  SAAS_ADMIN = 'saas_admin',
  SAAS_USER = 'saas_user',
  NCC_USER = 'ncc_user',
}
